var statisticsModule = angular.module('t2g.statistic', [
  'chart.js',
  'ui.router',
  require('t2g.common.data-access.statistic').name,
  require('t2g.common.services.modelService').name,
  require('t2g.common.services.notificationService').name,
]);

module.exports = statisticsModule;

statisticsModule.controller('StatisticSalesCtrl', require('./StatisticSalesCtrl'));

statisticsModule.config(function($stateProvider, ChartJsProvider) {
  ChartJsProvider.setOptions({
    chartColors: ['#364757', '#364757', '#364757', '#364757', '#364757', '#364757', '#364757'],
  });

  $stateProvider.state('private.main.statistic-sales', {
    url: '/statistic/sales?start&end&resolution',
    title: 'Statistics',
    templateUrl: '/app/modules/statistic/StatisticSalesView.html?v=4.5.6',
    controller: 'StatisticSalesCtrl as StatisticSalesCtrl',
    resolve: {
      salesResponse: function($stateParams, StatisticDA) {
        var today = moment();
        var start = $stateParams.start || today.startOf('month').format('YYYY-MM-DD');
        var end = $stateParams.end || today.endOf('month').format('YYYY-MM-DD');
        var resolution = 'day';

        return StatisticDA.getSales(start, end, resolution);
      },
      officeResolve: function(OfficeDA) {
        return OfficeDA.get();
      },
    },
  });
});



// WEBPACK FOOTER //
// ./src/app/modules/statistic/statisticModule.js